import React from 'react'
import NavbarOwner from './NavbarOwner';
import NavbarNormal from './NavbarNormal';
import { useSelector } from 'react-redux';

const NavbarRouter = () => {
  const variant = useSelector((store)=> store?.certificateVerification?.userType);

  return (
    <NavbarOwner/>
  )

}

export default NavbarRouter
